import UpdateRole from "../../features/dashboard/roles/UpdateRole";

function UpdateRolesDB() {
    return <UpdateRole />
}

export default UpdateRolesDB